<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="ajout-requisition-stepper">
    <div class="stepper-header mb-3 md:mb-4">
        <p class="text-sm text-500">
            {{items.length}} items sélectionnés répartis sur {{emplacementGroups.length}}
            emplacement{{emplacementGroups.length > 1 ? 's' : ''}}
        </p>
    </div>

    <p-steps [model]="getStepItems()" [(activeIndex)]="activeIndex" [readonly]="false"
        (activeIndexChange)="onStepChange($event)" class="mb-3 md:mb-4 stepper-responsive">
    </p-steps>

    <!-- Stepper Content -->
    <div *ngIf="!showResults && currentGroup" class="stepper-content mt-3">
        <p-card>
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-3 p-3">
                    <p-card>
                        <i class="pi pi-building text-primary text-xl"></i>
                    </p-card>
                    <div>
                        <h5 class="m-0">{{currentGroup.emplacement.nom}}</h5>
                        <p class="m-0 text-sm text-500">{{currentGroup.items.length}} items à traiter</p>
                    </div>
                </div>
            </ng-template>

            <!-- Items List -->
            <div class="mb-3 md:mb-4">
                <h6 class="mb-2">Items sélectionnés :</h6>
                <p-card>
                    <div *ngFor="let item of currentGroup.items"
                        class="flex flex-wrap sm:flex-nowrap align-items-center gap-2 mb-2 last:mb-0">
                        <span class="font-semibold text-sm sm:text-base">{{item.item.numero}}</span>
                        <span class="text-sm sm:text-base flex-1 min-w-0 truncate">{{item.item.description}}</span>
                        <p-tag [value]="'Qté: ' + item.quantiteDemande" severity="info" class="flex-shrink-0"></p-tag>
                    </div>
                </p-card>
            </div>

            <!-- Requisition Selection -->
            <div class="formgrid grid">
                <div class="field col-12">
                    <div class="flex flex-column gap-3">
                        <div class="flex flex-wrap align-items-center gap-2">
                            <p-radioButton inputId="existing-{{activeIndex}}" name="requisitionChoice-{{activeIndex}}"
                                value="existing" [(ngModel)]="currentGroup.requisitionChoice"
                                (onClick)="onRequisitionChoiceChange()">
                            </p-radioButton>
                            <label for="existing-{{activeIndex}}" class="font-semibold">
                                Ajouter à une réquisition existante
                            </label>
                        </div>

                        <div *ngIf="currentGroup.requisitionChoice === 'existing'" class="ml-0 md:ml-4">
                            <div *ngIf="loadingRequisitions" class="flex align-items-center gap-2">
                                <p-progressSpinner [style]="{width: '20px', height: '20px'}"></p-progressSpinner>
                                <span class="text-sm">Chargement des réquisitions...</span>
                            </div>

                            <div *ngIf="!loadingRequisitions">
                                <p-dropdown *ngIf="availableRequisitions.length > 0" [options]="availableRequisitions"
                                    [(ngModel)]="currentGroup.selectedRequisition" optionLabel="numero"
                                    placeholder="Sélectionner une réquisition..." [showClear]="true" appendTo="body"
                                    class="w-full">
                                    <ng-template let-requisition pTemplate="item">
                                        <div class="flex flex-column gap-1 p-2">
                                            <div class="flex align-items-center gap-2">
                                                <span class="font-semibold text-primary">{{requisition.numero}}</span>
                                                <p-tag [value]="requisition.date | date:'dd/MM/yyyy'"
                                                    severity="info"></p-tag>
                                            </div>
                                            <div class="flex align-items-center gap-2 text-sm">
                                                <i class="pi pi-user text-xs"></i>
                                                <span class="font-medium">{{requisition.demandeur?.prenom}}
                                                    {{requisition.demandeur?.nom}}</span>
                                            </div>
                                            <div class="grid pt-3 text-xs text-600"
                                                *ngIf="requisition.camion || requisition.chauffeur || requisition.remorque">
                                                <div class="col-4" *ngIf="requisition.camion">
                                                    <i class="pi pi-car mr-1"></i>{{requisition.camion}}
                                                </div>
                                                <div class="col-4" *ngIf="requisition.chauffeur">
                                                    <i class="pi pi-user mr-1"></i>{{requisition.chauffeur}}
                                                </div>
                                                <div class="col-4" *ngIf="requisition.remorque">
                                                    <i class="pi pi-truck mr-1"></i>{{requisition.remorque}}
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <ng-template let-requisition pTemplate="selectedItem">
                                        <div *ngIf="requisition" class="flex align-items-center gap-2">
                                            <span class="font-semibold">{{requisition.numero}}</span>
                                            <span class="text-sm text-500">- {{requisition.date |
                                                date:'dd/MM/yyyy'}}</span>
                                            <span class="text-sm text-500" *ngIf="requisition.demandeur">
                                                - {{requisition.demandeur?.prenom}} {{requisition.demandeur?.nom}}
                                            </span>
                                        </div>
                                    </ng-template>
                                </p-dropdown>

                                <div *ngIf="availableRequisitions.length === 0"
                                    class="text-center p-3 surface-100 dark:surface-700 border-round">
                                    <i class="pi pi-info-circle text-2xl mb-2"></i>
                                    <p class="m-0 text-sm">Aucune réquisition active trouvée pour cet emplacement</p>
                                </div>
                            </div>
                        </div>

                        <div class="flex align-items-center gap-2 mt-3">
                            <p-radioButton inputId="new-{{activeIndex}}" name="requisitionChoice-{{activeIndex}}"
                                value="new" [(ngModel)]="currentGroup.requisitionChoice"
                                (onChange)="onRequisitionChoiceChange()">
                            </p-radioButton>
                            <label for="new-{{activeIndex}}" class="font-semibold">
                                Créer une nouvelle réquisition
                            </label>
                        </div>

                        <!-- New Requisition Form -->
                        <p-card *ngIf="currentGroup.requisitionChoice === 'new' && currentGroup.newRequisitionData"
                            class="ml-0 md:ml-4 mt-3">
                            <div class="formgrid grid">
                                <div class="field col-12 sm:col-6 lg:col-4">
                                    <label for="transporteur-{{activeIndex}}" class="block font-semibold mb-2">
                                        Transporteur <span class="text-red-500">*</span>
                                    </label>
                                    <input id="transporteur-{{activeIndex}}" type="text" pInputText
                                        [(ngModel)]="currentGroup.newRequisitionData.transporteur"
                                        placeholder="Transporteur" class="w-full">
                                </div>

                                <div class="field col-12 sm:col-6 lg:col-4">
                                    <label for="camion-{{activeIndex}}" class="block font-semibold mb-2">
                                        Camion <span class="text-red-500">*</span>
                                    </label>
                                    <input id="camion-{{activeIndex}}" type="text" pInputText
                                        [(ngModel)]="currentGroup.newRequisitionData.camion" placeholder="Camion"
                                        class="w-full">
                                </div>

                                <div class="field col-12 sm:col-6 lg:col-4">
                                    <label for="chauffeur-{{activeIndex}}" class="block font-semibold mb-2">
                                        Chauffeur <span class="text-red-500">*</span>
                                    </label>
                                    <input id="chauffeur-{{activeIndex}}" type="text" pInputText
                                        [(ngModel)]="currentGroup.newRequisitionData.chauffeur" placeholder="Chauffeur"
                                        class="w-full">
                                </div>
                            </div>
                        </p-card>
                    </div>
                </div>
            </div>

            <!-- Navigation Buttons -->
            <div
                class="flex flex-column-reverse sm:flex-row justify-content-between align-items-stretch sm:align-items-center gap-2 mt-4">
                <p-button *ngIf="activeIndex > 0" label="Précédent" icon="pi pi-angle-left" iconPos="left"
                    [outlined]="true" (click)="previousStep()" class="w-full sm:w-auto">
                </p-button>

                <div class="flex flex-col sm:flex-row gap-2 w-full sm:w-auto sm:ml-auto">
                    <p-button label="Annuler" icon="pi pi-times" [outlined]="true" severity="secondary"
                        [disabled]="processing" (click)="cancel()" class="w-full sm:w-auto">
                    </p-button>

                    <p-button *ngIf="activeIndex < emplacementGroups.length - 1" label="Suivant"
                        icon="pi pi-angle-right" iconPos="right" [disabled]="!canProceedToNext()" (click)="nextStep()"
                        class="w-full sm:w-auto">
                    </p-button>

                    <p-button *ngIf="activeIndex === emplacementGroups.length - 1"
                        [label]="processing ? ('Traitement... (' + processingProgress + '%)') : 'Traiter'"
                        icon="pi pi-check" iconPos="right" [disabled]="!canProceedToNext() || processing"
                        [loading]="processing" (click)="nextStep()" class="w-full sm:w-auto">
                    </p-button>

                    <!-- Processing Progress -->
                    <div *ngIf="processing && currentProcessingGroup"
                        class="mt-3 p-3 surface-100 dark:surface-700 border-round w-full">
                        <div class="flex align-items-center gap-2 mb-2">
                            <i class="pi pi-spin pi-spinner"></i>
                            <span class="font-semibold">Traitement en cours...</span>
                        </div>
                        <div class="text-sm mb-2">
                            Emplacement: <strong>{{currentProcessingGroup}}</strong>
                        </div>
                        <p-progressBar [value]="processingProgress" [showValue]="true"></p-progressBar>
                    </div>
                </div>
            </div>
        </p-card>
    </div>

    <!-- Results -->
    <div *ngIf="showResults" class="results-content">
        <p-card>
            <ng-template pTemplate="header">
                <div class="flex align-items-center gap-3 p-3">
                    <div class="w-3rem h-3rem bg-green-100 border-round flex align-items-center justify-content-center">
                        <i class="pi pi-check text-green-600 text-xl"></i>
                    </div>
                    <div>
                        <h5 class="m-0">Traitement terminé</h5>
                        <p class="m-0 text-sm text-500">{{getTotalItemsProcessed()}} items traités au total</p>
                    </div>
                </div>
            </ng-template>

            <!-- Success Results -->
            <div *ngIf="getSuccessfulResults().length > 0" class="mb-4">
                <h6 class="text-green-600 mb-3">
                    <i class="pi pi-check-circle mr-2"></i>
                    Succès ({{getSuccessfulResults().length}})
                </h6>
                <div *ngFor="let result of getSuccessfulResults()"
                    class="p-3 surface-100 dark:surface-700 border-round mb-2">
                    <div class="flex align-items-center gap-3 mb-2">
                        <i class="pi pi-check-circle text-green-600"></i>
                        <div class="flex-1">
                            <div class="font-semibold">{{result.emplacement}}</div>
                            <div class="text-sm text-500">{{result.message}}</div>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <p-tag [value]="result.isNewRequisition ? 'Nouvelle' : 'Existante'"
                                [severity]="result.isNewRequisition ? 'success' : 'info'"></p-tag>
                        </div>
                    </div>
                    <div
                        class="flex flex-column sm:flex-row align-items-stretch sm:align-items-center justify-content-between gap-2 surface-0 dark:surface-800 p-2 border-round">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-file text-primary"></i>
                            <span class="font-medium">Réquisition: {{result.requisitionNumero}}</span>
                        </div>
                        <p-button label="Voir la réquisition" icon="pi pi-external-link" size="small" [outlined]="true"
                            (click)="navigateToRequisition(result.requisitionId!)">
                        </p-button>
                    </div>
                </div>
            </div>

            <!-- Error Results -->
            <div *ngIf="getFailedResults().length > 0" class="mb-4">
                <h6 class="text-red-600 mb-3">
                    <i class="pi pi-times-circle mr-2"></i>
                    Erreurs ({{getFailedResults().length}})
                </h6>
                <div *ngFor="let result of getFailedResults()"
                    class="flex flex-wrap align-items-center gap-3 p-3 surface-100 dark:surface-700 border-round mb-2">
                    <i class="pi pi-times-circle text-red-600"></i>
                    <div class="flex-1">
                        <div class="font-semibold">{{result.emplacement}}</div>
                        <div class="text-sm text-500">{{result.message}}</div>
                    </div>
                </div>
            </div>

            <!-- Close Button -->
            <div class="flex justify-content-center sm:justify-content-end mt-4">
                <p-button label="Fermer" icon="pi pi-times" iconPos="left" (click)="close()">
                </p-button>
            </div>
        </p-card>
    </div>
</div>